











import { Component, Mixins } from 'vue-property-decorator';
import CardMixin from '../common';

@Component
export default class PageOrganizationCardPhotos extends Mixins(CardMixin) {
  // Computed
  get hasPhotos() {
    return this.photos && this.photos.length > 0;
  }

  get photos() {
    return this.organization.photos;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/organizations/card/photos/component.vue